import { testingToolsApi } from "./testingTools";

export const {
  useStartPtlTestMutation,
  useSimulatePressPTLButtonMutation,
  useGetInternalTestEventFeedQuery,
  usePostInternalTestEventMutation
} = testingToolsApi;
